import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  bySongId: {}
};

const songSettingsSlice = createSlice({
  name: 'songSettings',
  initialState,
  reducers: {

    // Save / overwrite settings for a library song
    saveLibrarySongSettings: (state, action) => {
      const { songId, settings } = action.payload;

      if (!songId || !settings) return;

      state.bySongId[songId] = {
        ...settings,
        lastUpdatedAt: new Date().toISOString()
      };
    },

    // Optional: clear settings for one song
    clearLibrarySongSettings: (state, action) => {
      const { songId } = action.payload;
      delete state.bySongId[songId];
    },

    // Optional: wipe everything
    clearAllLibrarySongSettings: (state) => {
      state.bySongId = {};
    }
  }
});

export const {
  saveLibrarySongSettings,
  clearLibrarySongSettings,
  clearAllLibrarySongSettings
} = songSettingsSlice.actions;

export default songSettingsSlice.reducer;

export const selectLibrarySongSettingsById = (state) =>
  state.songSettings.bySongId;

